import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import BooleanInput from "../formElements/BooleanInput";
import PasswordInput from "../formElements/PasswordInput";

function ProductForm(props) {

    function customSubmit(data) {
        const formData = new FormData();
        formData.append('data', data);
        return formData
    }

    function parseData(newData) {
        newData.admin = newData.is_staff
        newData.firstName = newData.first_name
        newData.lastName = newData.last_name
        return newData
    }

    function parseFromData(data, parseFromData) {
        return {
            id: data.id,
            username: data.username,
            first_name: data.firstName,
            last_name: data.lastName,
            is_staff: data.admin,
            email: data.email,
            password: data.password
        }
    }

    const formContent = (data, update) => (
        <>
            <StringInput name={'username'} label={'Užívateľ'} value={data.username} onChange={update}/>
            <StringInput name={'firstName'} label={'Meno'} value={data.firstName} onChange={update}/>
            <StringInput name={'lastName'} label={'Priezvisko'} value={data.lastName} onChange={update}/>
            <StringInput name={'email'} label={'E-mail'} value={data.email} onChange={update}/>
            <PasswordInput name={'password'} label={'Heslo'} value={data.password} onChange={update}/>
            <BooleanInput name={'admin'} label={'Admin'} value={data.admin} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Užívateľ"
                     labelNew="Pridať užívateľa"
                     baseUrl='/users/'
                     contentType={'multipart/form-data'}
                     parseData={parseData}
                     parseFromData={parseFromData}
                     formContent={formContent}
                     customSubmit={customSubmit}
        />
    )
}

export default ProductForm
